export const RECENT_VISITS_KEY = "todo-recent-visits";

export const searchableDestinations = [
  { path: "/inbox", label: "Inbox", description: "Unorganized captured Tasks", aliases: "capture collect" },
  { path: "/today", label: "Today", description: "Tasks planned for today", aliases: "daily now" },
  { path: "/upcoming", label: "Upcoming", description: "Future schedules", aliases: "future soon" },
  { path: "/anytime", label: "Anytime", description: "Tasks available now", aliases: "available next" },
  { path: "/someday", label: "Someday", description: "Ideas to consider later", aliases: "later maybe" },
  { path: "/deadlines", label: "Deadlines", description: "Deadlines and overdue risks", aliases: "due overdue" },
  { path: "/repeating", label: "Repeating", description: "Repeat rules and generated Tasks", aliases: "repeat recurring" },
  { path: "/logbook", label: "Logbook", description: "Completed and Cancelled Tasks", aliases: "history completed cancelled" },
] as const;

export function readRecentVisits(): string[] {
  try {
    const value = JSON.parse(localStorage.getItem(RECENT_VISITS_KEY) ?? "[]");
    return Array.isArray(value) ? value.filter((item): item is string => typeof item === "string") : [];
  } catch {
    return [];
  }
}

export function rememberVisit(pathname: string) {
  if (!searchableDestinations.some((item) => item.path === pathname)) return;
  const next = [pathname, ...readRecentVisits().filter((item) => item !== pathname)].slice(0, 6);
  localStorage.setItem(RECENT_VISITS_KEY, JSON.stringify(next));
}
